"use client";
import {
  useCompositeStoreProps
} from "./VUP7S67H.js";
import {
  useStore,
  useStoreProps
} from "./2ID5JPOO.js";
import {
  __spreadProps,
  __spreadValues
} from "./2SMRF6AD.js";

// src/tab/tab-store.ts
import { useMemo } from "react";
import * as Core from "@ariakit/core/tab/tab-store";
function useTabStoreProps(store, update, props) {
  store = useCompositeStoreProps(store, update, props);
  useStoreProps(store, props, "selectedId", "setSelectedId");
  useStoreProps(store, props, "selectOnMove");
  const [panels] = useStore(() => store.panels, {});
  return useMemo(() => __spreadProps(__spreadValues({}, store), { panels }), []);
}
function useTabStore(props = {}) {
  const [store, update] = useStore(Core.createTabStore, props);
  return useTabStoreProps(store, update, props);
}

export {
  useTabStoreProps,
  useTabStore
};
